import { AnyAction } from '@reduxjs/toolkit';
import { CreateSurveysRoutine, DeleteSurveyRoutine, FetchSurveysRoutine } from '../redux-routines';
import { ISurvey, ISurveysState } from '../interfaces';

export type { ISurveysState };
const initialState: ISurveysState = {
  isFetching: false,
  data: [],
  error: null
};
export const surveysReducer = (
  state: ISurveysState = initialState,
  action: AnyAction
) => {
  let data: ISurvey[];
  switch (action.type) {
    case FetchSurveysRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchSurveysRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchSurveysRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case CreateSurveysRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case CreateSurveysRoutine.SUCCESS:
      data = [...state.data, action.payload];
      return {
        ...state,
        isFetching: false,
        data,
        error: null
      };
    case CreateSurveysRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case DeleteSurveyRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case DeleteSurveyRoutine.SUCCESS:
      data = state.data.filter((survey) => survey.surveyId !== action.payload);
      return {
        ...state,
        isFetching: false,
        data,
        error: null
      };
    case DeleteSurveyRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};